<script lang="ts" setup>
defineProps<{
  collapsed?: boolean
}>()
</script>

<template>
  <Transition name="v-sidebar-nav-header">
    <div
      v-show="!collapsed"
      class="mt-6 h-[28px] px-3 text-ui-label-12 font-medium text-general-tertiary"
    >
      <slot />
    </div>
  </Transition>
</template>

<style scoped>
.v-sidebar-nav-header-enter-active {
  transition:
    height 0.15s ease 0s,
    margin-top 0.15s ease 0s,
    opacity 0.15s ease 0.3s;
}

.v-sidebar-nav-header-leave-active {
  transition:
    height 0.15s ease 0.45s,
    margin-top 0.15s ease 0.45s,
    opacity 0.15s ease 0s;
}

.v-sidebar-nav-header-enter-from,
.v-sidebar-nav-header-leave-to {
  opacity: 0;
  height: 0;
  margin-top: 0;
  overflow: hidden;
}

.v-sidebar-nav-header-enter-to,
.v-sidebar-nav-header-leave-from {
  opacity: 1;
  height: 28px;
  margin-top: 24px;
}
</style>
